import { MERGE_FUEL_ECONOMY_FROM_API } from '../actionTypes/fuelEconomyActionTypes';
import type { MergeFuelEconomyFromApiPayload } from '../types/fuelEconomyTypes';

/**
 * Merges fuel-economy values returned from the CVI fuel-economy API onto the
 * matching selling vehicle and trade-in records in Redux. The values flow into
 * the next saveOffer payload via the vehicle/tradeIn spreads, so subsequent
 * init responses can return the MPG values directly without a follow-up CVI
 * call.
 */
export const mergeFuelEconomyFromApi = (payload: MergeFuelEconomyFromApiPayload) => ({
    type: MERGE_FUEL_ECONOMY_FROM_API,
    payload
});
